import { useBudouX } from "@/hooks/useBudouX";
import Image from "next/image";
import { Br } from "../molecules/Br";
import aboutGreeting from "/public/photo-aboutGreeting.webp";
import aboutGreetingSP from "/public/photo-aboutGreetingSP.webp";

export const AboutGreeting = (props) => {
  const { parse } = useBudouX();
  return (
    <div id="greeting" className="--offset">
      <div className="relative mx-auto box-border max-w-7xl space-y-8 lg:px-0">
        <div className="relative z-10 aspect-1/1 w-full md:aspect-[2.12/1]">
          <span className="hidden md:block">
            <Image
              src={aboutGreeting}
              alt="経営環境の変化に対応するためのお手伝いを"
              quality={80}
              layout="fill"
              objectFit="cover"
            />
          </span>
          <span className="block md:hidden">
            <Image
              src={aboutGreetingSP}
              alt="経営環境の変化に対応するためのお手伝いを"
              quality={80}
              layout="fill"
              objectFit="cover"
            />
          </span>
        </div>
        <div className="grid grid-cols-1 gap-4 px-6 sm:px-8 md:grid-cols-4 md:px-12 xl:px-0">
          <div className="col-span-1">
            <h3 className="font-bold text-ter fluid-text-[16px,18px]">
              Greeting
            </h3>
          </div>
          <div className="col-span-1 leading-loose text-txt-base fluid-text-[14px,18px] md:col-span-3">
            {parse("私たちToccaSystemsは2008年に設立致しました。")}
            <Br />
            {parse(
              "日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供できる会社を目指して、歩んでまいりました。派手さはない地道な会社ですが、デジタルテクノロジーの持つ合理性に、思いやりや創造性を掛け合わせた、お客様に寄り添える、人の顔が見えるサービスをお届けしたいと考えています。今後とも、ToccaSystemsへのご期待とご支援を賜りますよう、よろしくお願い申し上げます。"
            )}
            <div className="mt-2 leading-relaxed text-txt-base md:text-right">
              <span className="text-ter">株式会社トッカシステムズ</span>
              <Br sp />
              <span className="text-ter md:ml-2">代表取締役</span>
              <Br />
              <strong>谷 樹</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
